//@flow
import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import FilterButton from '../../../../elements/HorizontalFilter/FilterButton/FilterButton';
import {colors} from '../../../../assets/styles/colors';
import {useToggleFilter} from '../../utils/productFilters';
import {useStorePromotions} from '../../../marketing/promotions/utils';

const useStyles = makeStyles(theme => ({
  filterItemContainer: {
    display: 'flex',

    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },

    '&::-webkit-scrollbar-track': {
      background: colors.grey200,
      borderRadius: '5px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: colors.grey400,
      borderRadius: '5px',
    },
  },
  categoriesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '.5rem',
  },
}));

export default function PromotionFilter() {
  const {filter, resetFilters, toggleFilterValue} = useToggleFilter();
  const promotions = useStorePromotions();

  const classes = useStyles();

  return (
    <div className={classes.filterItemContainer}>
      <div className={classes.categoriesContainer}>
        <FilterButton
          id="all"
          handleOnClick={resetFilters}
          selected={filter.value.length === 0}
          text="todos"
        />

        {promotions &&
          promotions.map((promotion, index: number) => (
            <FilterButton
              key={promotion.id}
              selected={filter.value.includes(promotion.id)}
              id={promotion.id}
              handleOnClick={() => {
                toggleFilterValue(promotion.id);
              }}
              text={promotion.name}
            />
          ))}
      </div>
    </div>
  );
}
